import BannerPanel from "../../../components/bannerPanel/bannerPanel";

import styles from "./lowerBannerPanel.module.scss"

function LowerBannerPanel({ blok, lower_banner_panel }) {
  if(!lower_banner_panel) { return null }
  const { link, desktop_image, mobile_image} = lower_banner_panel;

  return (
    <section className={`${styles.lowerBannerPanel} ${blok && blok.margin_top ? styles.marginTopDefault : ""} ${blok && blok.margin_bottom ? styles.marginBottomDefault : ""}`}>
      <BannerPanel link={link} desktop_image={desktop_image} mobile_image={mobile_image} />
    </section>
  )
}

export default LowerBannerPanel
